import { render, staticRenderFns } from "./EditWholesalerComponent.vue?vue&type=template&id=a6e7bc5a&"
import script from "./EditWholesalerComponent.vue?vue&type=script&lang=js&"
export * from "./EditWholesalerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports